/*
 * Rabattfortschritt (Anpassung dotSHOP, eigene Datei).
 * Spezifikation: shopify-toolkit/playbook/rabattfortschritt.md
 *
 * Datenquelle: shop.metafields.konditionen.schwellen (make schwellen).
 * Bezugsgroessen, im Warenkorb belegt:
 *   - Bestellrabatte: kombinierbare addieren sich, von nicht kombinierbaren
 *     nimmt Shopify den hoechsten.
 *   - Produktrabatte (Aktion auf einen Teil des Sortiments) wirken zuerst; die
 *     Bestellrabatte rechnen danach auf den reduzierten Betrag, und ihre
 *     Schwellen gelten fuer ihn. Shopify gibt die guenstigere Kombination.
 *   - Versandschwellen greifen auf den Warenwert nach Rabatt.
 * Angezeigt wird immer, was der Kunde noch in LISTENPREISEN in den Korb
 * legen muss.
 */
(function (global) {
  'use strict';

  var CENT = 0.005;

  function aktiveRabatte(rabatte, jetzt) {
    return (rabatte || []).filter(function (r) {
      if (r.beginnt && new Date(r.beginnt) > jetzt) return false;
      if (r.endet && new Date(r.endet) <= jetzt) return false;
      return r.prozent > 0;
    });
  }

  /**
   * Rabatte auf einen Teil des Sortiments (Aktion der Woche) gelten nur fuer
   * Artikel aus diesen Kollektionen (r.kollektionen) bzw. mit diesen
   * Artikelnummern (r.skus). auswahl = je Artikel { sku, kollektionen }
   * (Warenkorb, Produktseite, Konfiguration); null = unbekannt.
   * Rueckgabe: 'alle' (jeder Artikel drin), 'teils', 'keine' oder 'unbekannt'.
   */
  function artikelTrifft(r, artikel) {
    if (Array.isArray(artikel)) artikel = { kollektionen: artikel };
    artikel = artikel || {};
    if (r.skus) return !!artikel.sku && r.skus.indexOf(String(artikel.sku)) >= 0;
    var handles = r.kollektionen.map(function (k) { return k.handle; });
    return (artikel.kollektionen || []).some(function (h) { return handles.indexOf(h) >= 0; });
  }
  function trifft(r, auswahl) {
    if (!r.kollektionen && !r.skus) return 'alle';
    if (!auswahl || !auswahl.length) return 'unbekannt';
    var n = auswahl.filter(function (artikel) { return artikelTrifft(r, artikel); }).length;
    return n === auswahl.length ? 'alle' : n ? 'teils' : 'keine';
  }

  /** Name des Teilsortiments fuer die Statuszeile ([kollektion]). */
  function umfangText(r) {
    if (r.kollektionen) return r.kollektionen.map(function (k) { return k.titel; }).join(', ');
    return r.umfang || r.titel || '';
  }

  /** Rabatte, die auf die ganze Auswahl wirken - nur die rechnet der Baustein ein. */
  function wirksameRabatte(schwellen, jetzt, auswahl) {
    return aktiveRabatte(schwellen && schwellen.rabatte, jetzt).filter(function (r) { return trifft(r, auswahl) === 'alle'; });
  }

  /** Rabatt auf einen Teil des Sortiments (Produktrabatt in Shopify)? */
  function istProdukt(r) { return !!(r.kollektionen || r.skus); }

  /** Satz der Bestellrabatte beim Warenwert basis: kombinierbare addieren sich, sonst der hoechste. */
  function bestellSatz(rabatte, basis) {
    var summe = 0, einzeln = 0;
    rabatte.forEach(function (r) {
      if (istProdukt(r) || r.ab > basis + CENT) return;
      if (r.kombinierbar) summe += r.prozent; else einzeln = Math.max(einzeln, r.prozent);
    });
    return Math.max(summe, einzeln) / 100;
  }

  /**
   * Rabattsatz (0..1) beim Listenwert w, so wie Shopify rechnet (im Warenkorb
   * belegt 01.11.2026): Der Produktrabatt wird zuerst abgezogen, die
   * Bestellrabatte danach auf den reduzierten Betrag, und ob sie greifen,
   * entscheidet dieser reduzierte Betrag. Gehen nicht beide zugleich, gibt
   * Shopify die fuer den Kunden guenstigere Variante.
   *   5 % Aktion + 20 % ab 1.250 bei 1.834,50 Liste: 0,95 x 0,80 -> 24 %
   *   dasselbe bei 1.262,50: 1.199,38 nach Aktion < 1.250 -> nur die 20 %
   */
  function satz(rabatte, w) {
    var p = 0, pKombi = true;
    rabatte.forEach(function (r) {
      if (!istProdukt(r) || r.ab > w + CENT) return;
      if (r.prozent / 100 > p) { p = r.prozent / 100; pKombi = r.kombinierbar !== false; }
    });
    var nurProdukt = 1 - p;
    var nurBestellung = 1 - bestellSatz(rabatte, w);
    var beide = pKombi ? (1 - p) * (1 - bestellSatz(rabatte, w * (1 - p))) : 1;
    return Math.round((1 - Math.min(nurProdukt, nurBestellung, beide)) * 1e6) / 1e6;
  }

  function nachRabatt(rabatte, w) { return w * (1 - satz(rabatte, w)); }

  /** Listenwerte, an denen sich der Satz aendern kann: jede Schwelle, auch umgerechnet ueber den Produktrabatt. */
  function grenzenVon(rabatte) {
    var faktoren = [1];
    rabatte.forEach(function (r) { if (istProdukt(r) && r.prozent > 0 && r.prozent < 100) faktoren.push(1 - r.prozent / 100); });
    var g = [0];
    rabatte.forEach(function (r) { faktoren.forEach(function (f) { g.push(Math.round((r.ab / f) * 100) / 100); }); });
    return g.filter(function (a, i, x) { return x.indexOf(a) === i; }).sort(function (a, b) { return a - b; });
  }

  /** Kleinster Listenwert >= w, bei dem der Wert nach Rabatt >= ziel ist. */
  function listenwertFuer(rabatte, w, ziel) {
    var grenzen = grenzenVon(rabatte);
    for (var i = 0; i < grenzen.length; i++) {
      var von = grenzen[i], bis = i + 1 < grenzen.length ? grenzen[i + 1] : Infinity;
      if (bis <= w) continue;
      var s = satz(rabatte, Math.max(von, w));
      var kandidat = Math.max(von, w, Math.ceil((ziel / (1 - s)) * 100 - 1e-6) / 100);
      if (kandidat < bis && nachRabatt(rabatte, kandidat) >= ziel - CENT) return kandidat;
    }
    return null;
  }

  function versandStufe(versand, v) {
    var treffer = null;
    (versand || []).forEach(function (s) {
      if (s.ab <= v + CENT && (s.bis == null || v <= s.bis + CENT)) {
        if (!treffer || s.preis < treffer.preis) treffer = s;
      }
    });
    return treffer;
  }

  /**
   * Was als naechstes kommt.
   *   { art: 'lieferung'|'versandfrei'|'rabatt'|'erreicht'|'nichts',
   *     fehlt, ziel, von, prozent, ersparnis, satzJetzt, kombiniert }
   */
  function naechstes(schwellen, w, jetzt, auswahl) {
    jetzt = jetzt || new Date();
    var rabatte = wirksameRabatte(schwellen, jetzt, auswahl);
    var versand = (schwellen && schwellen.versand) || [];
    if (!rabatte.length && !versand.length) return { art: 'nichts' };

    var v = nachRabatt(rabatte, w);
    var stufe = versandStufe(versand, v);
    var satzJetzt = satz(rabatte, w);
    var kandidaten = [];

    // Versand: naechst guenstigere Stufe (oder ueberhaupt eine Lieferung)
    versand.filter(function (s) { return s.ab > v + CENT; })
      .sort(function (a, b) { return a.ab - b.ab; })
      .forEach(function (s) {
        if (stufe && s.preis >= stufe.preis) return;
        var ziel = listenwertFuer(rabatte, w, s.ab);
        if (ziel == null) return;
        kandidaten.push({
          art: stufe ? 'versandfrei' : 'lieferung',
          ziel: ziel, fehlt: ziel - w, preis: s.preis,
          ersparnis: stufe ? stufe.preis - s.preis : 0,
          nachRabattGerechnet: satzJetzt > 0,
        });
      });

    // Rabatt: naechste Schwelle, an der der Satz steigt
    grenzenVon(rabatte)
      .filter(function (a) { return a > w + CENT; })
      .forEach(function (a) {
        var neu = satz(rabatte, a);
        if (neu <= satzJetzt) return;
        if (kandidaten.some(function (k) { return k.art === 'rabatt'; })) return;
        var ersparnis = nachRabatt(rabatte, w) + (a - w) - nachRabatt(rabatte, a);
        kandidaten.push({ art: 'rabatt', ziel: a, fehlt: a - w, prozent: Math.round(neu * 1000) / 10, ersparnis: ersparnis });
      });

    if (!kandidaten.length) return { art: 'erreicht', satzJetzt: satzJetzt, versandfrei: !!(stufe && stufe.preis === 0), mitRabatt: rabatte.length > 0 };

    // Ohne Lieferung zaehlt nichts anderes. Sonst: die naechste Schwelle.
    var lieferung = kandidaten.filter(function (k) { return k.art === 'lieferung'; })[0];
    kandidaten.sort(function (a, b) { return a.fehlt - b.fehlt; });
    var erstes = lieferung || kandidaten[0];

    // Zwei Schwellen fast gleichauf: eine Aussage daraus machen
    var zweites = kandidaten.filter(function (k) { return k !== erstes && Math.abs(k.fehlt - erstes.fehlt) <= 10; })[0];
    if (zweites) erstes.kombiniert = zweites;

    // Balken: vom letzten erreichten Punkt bis zum Ziel
    var punkte = [0].concat(rabatte.map(function (r) { return r.ab; }));
    versand.forEach(function (s) { var z = listenwertFuer(rabatte, 0, s.ab); if (z != null) punkte.push(z); });
    erstes.von = Math.max.apply(null, punkte.filter(function (p) { return p <= w + CENT; }));
    erstes.satzJetzt = satzJetzt;
    return erstes;
  }

  global.Rabattfortschritt = { satz: satz, grenzenVon: grenzenVon, nachRabatt: nachRabatt, listenwertFuer: listenwertFuer, naechstes: naechstes, aktiveRabatte: aktiveRabatte, statusPunkte: statusPunkte, trifft: trifft, wirksameRabatte: wirksameRabatte };

  // ---------------------------------------------------------------- Anzeige
  if (typeof document === 'undefined') return;

  var euro = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR' });

  function fuelle(text, werte) {
    return String(text || '').replace(/\[(\w+)\]/g, function (_, k) { return werte[k] != null ? werte[k] : ''; });
  }

  function satzText(el, e, t) {
    if (e.art === 'lieferung') return fuelle(t.lieferung, { betrag: euro.format(e.fehlt), versand: euro.format(e.preis) });
    if (e.art === 'versandfrei') return fuelle(t.versandfrei, { betrag: euro.format(e.fehlt), ersparnis: euro.format(e.ersparnis) });
    if (e.art === 'rabatt') {
      var s = fuelle(t.rabatt, { betrag: euro.format(e.fehlt), prozent: String(e.prozent).replace('.', ',') });
      if (e.ersparnis >= 1) s += fuelle(t.ersparnis, { ersparnis: euro.format(e.ersparnis) });
      return s;
    }
    return '';
  }

  var euroGanz = new Intl.NumberFormat('de-DE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 });
  function betragText(b) { return Math.abs(b - Math.round(b)) < CENT ? euroGanz.format(Math.round(b)) : euro.format(b); }
  /**
   * Text mit Platzhaltern als Knoten anhaengen; {so markierte} Teile werden
   * Links auf die Rabatte-Seite (nachlesen, wo die Schwelle liegt oder
   * welches Sortiment die Aktion bekommt). Ohne Link-Ziel bleibt nur der Text.
   */
  function fuelleKnoten(ziel, text, link) {
    String(text || '').split(/(\{[^}]*\})/).forEach(function (teil) {
      if (!teil) return;
      var m = /^\{([^}]*)\}$/.exec(teil);
      if (m && link) {
        var a = document.createElement('a');
        a.className = 'rabattfortschritt__link';
        a.href = link;
        a.textContent = m[1];
        ziel.appendChild(a);
      } else {
        ziel.appendChild(document.createTextNode(m ? m[1] : teil));
      }
    });
  }

  function prozentText(s) { return String(Math.round(s * 1000) / 10).replace('.', ','); }

  /**
   * Statuszeilen unter dem Satz (Haken bzw. rotes Kreuz, Zeichen per CSS):
   *   - Hoechstrabatt erreicht
   *   - Lieferung per Spedition moeglich oder erst ab Mindestwarenwert -
   *     nur wenn der Shop ueberhaupt erst ab einem Mindestwert liefert
   *   - sonst: kostenlose Lieferung erreicht, sobald sie greift - auch wenn
   *     noch eine Rabattstufe kommt
   */
  function statusPunkte(schwellen, w, e, t, auswahl) {
    var punkte = [];
    var alleRabatte = aktiveRabatte(schwellen && schwellen.rabatte, new Date());
    var rabatte = alleRabatte.filter(function (r) { return trifft(r, auswahl) === 'alle'; });
    var versand = (schwellen && schwellen.versand) || [];
    var jetzt = satz(rabatte, w);
    if (jetzt > 0 && jetzt >= satz(rabatte, Infinity)) {
      punkte.push({ ja: true, art: 'ja', text: fuelle(t.erreicht_rabatt, { prozent: prozentText(jetzt) }) });
    }
    // Aktion auf einen Teil des Sortiments, die nicht die ganze Auswahl trifft:
    // sagen, was gilt (teils: Haken; gar nicht: grauer Hinweis, kein Fehler)
    alleRabatte.filter(function (r) { return r.kollektionen || r.skus; }).forEach(function (r) {
      var wie = trifft(r, auswahl);
      if (wie === 'alle' || wie === 'unbekannt') return;
      var werte = { prozent: prozentText(r.prozent / 100), kollektion: umfangText(r) };
      punkte.push({ ja: wie === 'teils', art: wie === 'teils' ? 'ja' : 'info', text: fuelle(wie === 'teils' ? t.aktion_teils : t.aktion_nein, werte) });
    });
    var mindestwert = versand.length && !versand.some(function (s) { return s.ab <= CENT; });
    if (mindestwert) {
      var stufe = versandStufe(versand, nachRabatt(rabatte, w));
      if (stufe) punkte.push({ ja: true, art: 'ja', text: stufe.preis === 0 ? t.spedition_frei : t.spedition_ja });
      else punkte.push({ ja: false, art: 'nein', text: fuelle(t.spedition_nein, { betrag: betragText(Math.min.apply(null, versand.map(function (s) { return s.ab; }))) }) });
    } else {
      var kosten = versandStufe(versand, nachRabatt(rabatte, w));
      if (kosten && kosten.preis === 0) punkte.push({ ja: true, art: 'ja', text: t.erreicht_versand });
    }
    return punkte;
  }

  function zeichne(el, w) {
    var t = JSON.parse(el.getAttribute('data-texte'));
    var schwellen = JSON.parse(el.getAttribute('data-schwellen') || 'null');
    var auswahl = auswahlVon(el);
    var e = naechstes(schwellen, w, null, auswahl);
    var satzEl = el.querySelector('[data-satz]');
    var hinweisEl = el.querySelector('[data-hinweis]');
    var balken = el.querySelector('[data-balken]');
    var statusEl = el.querySelector('[data-status]');

    if (e.art === 'nichts' || w <= 0) { el.hidden = true; return; }
    var punkte = statusPunkte(schwellen, w, e, t, auswahl);
    // Alles erreicht: kein Balken mehr, nur noch die Statuszeilen
    var erreicht = e.art === 'erreicht';
    if (erreicht && !punkte.length) { el.hidden = true; return; }
    el.hidden = false;

    var text = '';
    if (!erreicht) {
      text = satzText(el, e, t);
      if (e.kombiniert) {
        var k = e.kombiniert;
        var kurz = k.art === 'rabatt' ? fuelle(t.kurz_rabatt, { prozent: String(k.prozent).replace('.', ',') }) : (k.art === 'versandfrei' ? t.kurz_versandfrei : t.kurz_lieferung);
        text += fuelle(t.und, { weiteres: kurz });
      }
    } else if (el.classList.contains('rabattfortschritt--kurz')) {
      // Kurzform (Mobilleiste) zeigt keine Statuszeilen - das Wichtigste in den Satz
      text = punkte[0].text;
    }
    var ort = el.getAttribute('data-ort');
    // Vorsatz; liegt schon etwas im Warenkorb, steht das dabei (er zaehlt mit)
    var mitKorb = el._korb > CENT;
    var vorsatz = ort === 'produkt' ? (mitKorb && t.mit_artikel_korb ? fuelle(t.mit_artikel_korb, { betrag: euro.format(el._korb) }) : t.mit_artikel)
      : ort === 'konfigurator' ? (mitKorb && t.mit_konfiguration_korb ? fuelle(t.mit_konfiguration_korb, { betrag: euro.format(el._korb) }) : (t.mit_konfiguration || '')) : '';
    satzEl.textContent = '';
    // Vorsatz als eigenes Element: Der Konfigurator kann ihn so in eine eigene Zeile stellen
    if (vorsatz) {
      var v = document.createElement('span');
      v.className = 'rabattfortschritt__vorsatz';
      v.textContent = vorsatz;
      satzEl.appendChild(v);
    }
    if (erreicht && text) {
      var haken = document.createElement('span');
      haken.className = 'rabattfortschritt__haken';
      satzEl.appendChild(haken);
    }
    var link = t.rabatte_url || '';
    if (text) fuelleKnoten(satzEl, text, link);
    satzEl.hidden = !vorsatz && !text;

    balken.parentNode.hidden = erreicht;
    hinweisEl.textContent = (!erreicht && e.art !== 'rabatt' && e.nachRabattGerechnet) ? fuelle(t.nach_rabatt, { prozent: prozentText(e.satzJetzt) }) : '';
    if (!erreicht) {
      var anteil = e.ziel > e.von ? (w - e.von) / (e.ziel - e.von) : 1;
      balken.style.width = Math.max(4, Math.min(100, Math.round(anteil * 100))) + '%';
    }

    if (statusEl) {
      statusEl.textContent = '';
      punkte.forEach(function (p) {
        var li = document.createElement('li');
        li.className = 'rabattfortschritt__punkt rabattfortschritt__punkt--' + (p.art || (p.ja ? 'ja' : 'nein'));
        fuelleKnoten(li, p.text, link);
        statusEl.appendChild(li);
      });
      statusEl.hidden = !punkte.length;
    }
  }

  function korbwert() {
    return fetch((global.routes && global.routes.cart_url ? global.routes.cart_url : '/cart') + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (c) { return c.original_total_price / 100; });
  }

  /**
   * Auswahl = je Artikel { sku, kollektionen } (fuer Rabatte auf einen Teil
   * des Sortiments): Warenkorb-Positionen aus data-auswahl, auf der
   * Produktseite dazu der Artikel (data-artikel-auswahl), im Konfigurator die
   * Artikel der Konfiguration (SKUs von der App, Kollektionen dazu aufgeloest,
   * siehe auswahlFuerSkus). null, solange die Konfiguration noch nicht
   * aufgeloest ist.
   */
  function auswahlVon(el) {
    var ort = el.getAttribute('data-ort');
    var korb = JSON.parse(el.getAttribute('data-auswahl') || '[]');
    if (ort === 'produkt') return korb.concat([JSON.parse(el.getAttribute('data-artikel-auswahl') || '{}')]);
    if (ort === 'konfigurator') {
      if (el._artikel <= CENT) return korb;
      if (!el._konfigAuswahl) return null;
      return korb.concat(el._konfigAuswahl);
    }
    return korb;
  }

  // Produkte je Aktionskollektion, einmal je Seite geladen (oeffentliches products.json)
  var kollektionsSkus = {};
  function skusDerKollektion(handle) {
    if (!kollektionsSkus[handle]) {
      kollektionsSkus[handle] = fetch('/collections/' + handle + '/products.json?limit=250', { headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw new Error(String(r.status)); return r.json(); })
        .then(function (d) {
          var skus = {};
          (d.products || []).forEach(function (p) { (p.variants || []).forEach(function (v) { if (v.sku) skus[v.sku] = true; }); });
          return skus;
        })
        // nicht ladbar: Zuordnung bleibt unbekannt, der Baustein schweigt dann zur Aktion
        .catch(function () { delete kollektionsSkus[handle]; return null; });
    }
    return kollektionsSkus[handle];
  }

  /** Je SKU der Konfiguration { sku, kollektionen }; die Handles der Aktions-
      kollektionen werden nur geladen, wenn es Rabatte auf Kollektionen gibt. */
  function auswahlFuerSkus(schwellen, skus) {
    var handles = [];
    aktiveRabatte(schwellen && schwellen.rabatte, new Date()).forEach(function (r) {
      (r.kollektionen || []).forEach(function (k) { if (handles.indexOf(k.handle) < 0) handles.push(k.handle); });
    });
    if (!handles.length) return Promise.resolve(skus.map(function (sku) { return { sku: sku, kollektionen: [] }; }));
    return Promise.all(handles.map(skusDerKollektion)).then(function (listen) {
      if (listen.some(function (l) { return !l; })) return null;
      return skus.map(function (sku) {
        return { sku: sku, kollektionen: handles.filter(function (h, i) { return listen[i][sku]; }) };
      });
    });
  }

  function wertVon(el) {
    var ort = el.getAttribute('data-ort');
    return el._korb + (ort === 'produkt' || ort === 'konfigurator' ? el._artikel * el._menge : 0);
  }

  /** Einen Baustein anwerfen. Dawn baut den Summenbereich im Warenkorb bei
      jeder Mengenaenderung neu auf - der neue Baustein kommt mit frischem
      data-korb vom Server und wird hier nachtraeglich angeworfen. */
  function anwerfen(el) {
    if (el._rf) return;
    el._rf = true;
    el._korb = Number(el.getAttribute('data-korb')) / 100;
    el._artikel = Number(el.getAttribute('data-artikel') || 0) / 100;
    el._menge = 1;
    el._neu = function () { zeichne(el, wertVon(el)); };
    el._neu();
    if (el.getAttribute('data-ort') === 'produkt') {
      var bereich = el.closest('section') || document;
      // 'input' fuer das Eintippen, 'change' fuer die Plus-/Minus-Knoepfe
      var mengeNeu = function (ev) {
        if (ev.target && ev.target.name === 'quantity') { el._menge = Math.max(1, Number(ev.target.value) || 1); el._neu(); }
      };
      bereich.addEventListener('input', mengeNeu);
      bereich.addEventListener('change', mengeNeu);
    }
  }

  function alle() { return document.querySelectorAll('[data-rabattfortschritt]'); }

  /**
   * Konfigurator (k5fence-App, auf einer Shopify-Seite eingebettet): Die App
   * stellt einen leeren Platz bereit und meldet den Listenpreis der
   * Konfiguration in Euro. Schwellen, Texte und Korbwert kommen aus der
   * Vorlage, die das Theme auf jeder Seite rendert
   * ([data-rabattfortschritt-vorlage]). Gestaltung und Rechnung sind damit
   * dieselben wie im Shop.
   *   Rabattfortschritt.konfigurator(platz, { wert: 1234.5, kurz: false, skus: ['A1', 'B2'] })
   * skus: Artikelnummern der Konfiguration (= Shopify-SKUs), damit Rabatte
   * auf einen Teil des Sortiments (Aktion der Woche) richtig zugeordnet werden.
   * Rueckgabe false, wenn die Seite keine Vorlage hat.
   */
  function konfigurator(platz, angaben) {
    if (!platz) return false;
    angaben = angaben || {};
    var el = platz.querySelector('[data-rabattfortschritt]');
    if (!el) {
      var vorlage = document.querySelector('[data-rabattfortschritt-vorlage]');
      if (!vorlage) return false;
      el = vorlage.cloneNode(true);
      el.removeAttribute('data-rabattfortschritt-vorlage');
      el.setAttribute('data-rabattfortschritt', '');
      if (angaben.kurz) el.classList.add('rabattfortschritt--kurz');
      platz.appendChild(el);
      anwerfen(el);
    }
    el._artikel = Math.max(0, Number(angaben.wert) || 0);
    el._menge = 1;
    var skus = (angaben.skus || []).map(String).filter(Boolean).filter(function (x, i, a) { return a.indexOf(x) === i; });
    var schluessel = skus.slice().sort().join('|');
    if (schluessel !== el._konfigSkus) {
      el._konfigSkus = schluessel;
      el._konfigAuswahl = null;
      var schwellen = JSON.parse(el.getAttribute('data-schwellen') || 'null');
      auswahlFuerSkus(schwellen, skus).then(function (auswahl) {
        if (el._konfigSkus !== schluessel) return;
        el._konfigAuswahl = auswahl;
        el._neu();
      });
    }
    el._neu();
    return true;
  }
  global.Rabattfortschritt.konfigurator = konfigurator;

  function start() {
    if (global.__rabattfortschrittLaeuft) return;
    global.__rabattfortschrittLaeuft = true;
    alle().forEach(anwerfen);
    // Fuer eingebettete Apps, die vor diesem Skript geladen haben
    document.dispatchEvent(new CustomEvent('rabattfortschritt:bereit'));

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.cartUpdate, function () {
        alle().forEach(anwerfen);
        korbwert().then(function (k) { alle().forEach(function (el) { el._korb = k; el._neu(); }); });
      });
      subscribe(PUB_SUB_EVENTS.variantChange, function (ev) {
        var v = ev && ev.data && ev.data.variant;
        if (!v) return;
        alle().forEach(function (el) { if (el.getAttribute('data-ort') === 'produkt') { el._artikel = v.price / 100; el._neu(); } });
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})(typeof window !== 'undefined' ? window : globalThis);
